import { Component } from '@angular/core';

@Component({
  selector: 'app-safe-zone',
  standalone: true,
  imports: [],
  templateUrl: './safe-zone.component.html',
  styleUrl: './safe-zone.component.css'
})
export class SafeZoneComponent {

}
